import {
    createUnknownComponentVNode as _$cc,
    createVNode as _$cv,
    className as _$cn,
    createElementVNode as _$ce,
    noop as _$no,
    createTextVNode as _$ct,
} from 'intact';
import {Button} from '../button';
import {Icon} from '../icon';
import {makeStyles} from './styles';
import {TourContext} from './tour';
import {getRestProps} from '../utils';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    var _$blocks = {};
    var __$blocks = {};
    
    const {
        title,
        content,
        className,
        children,
        nextText,
        prevText
    } = this.get();
    
    const { k } = this.config;
    
    const classNameObj = {
        [`${k}-tour-step`]: true,
        [className]: className,
    };
    
    return _$cc(TourContext.Consumer, {
        'children': ({value, total, doneText, onPrev, onNext, onFinish, closable}) => {
            const isFirst = value === 0;
            const isLast = value === total - 1;
            const showHeader = !!title;
            const displayIndex = value + 1;
        
            return (
                _$cv('div', {
                    'className': _$cn(classNameObj),
                    ...getRestProps(this)
                }, [
                    null,
                    (!!title || $blocks.header) ?
                        _$ce(2, 'div', [
                            _$ce(2, 'div', (
                                (
                                    (_$blocks['header'] = function($super) {
                                        return title;
                                    }),
                                    (__$blocks['header'] = function($super, data) {
                                        var block = $blocks['header'];
                                        var callBlock = function() {
                                            return _$blocks['header'].call($this, $super, data);
                                        };
                                        return block ?
                                            block.call($this, callBlock, data) :
                                            callBlock();
                                    }),
                                    __$blocks['header'](_$no)
                                )
                            ), 0 /* UnknownChildren */, _$cn(`${k}-tour-step-title`)),
                            (!closable) ?
                                _$ce(2, 'div', (
                                    _$cc(Icon, {
                                        'className': _$cn(`${k}-icon-close`)
                                    })
                                ), 2 /* HasVNodeChildren */, _$cn(`${k}-tour-step-close`), {
                                    'ev-click': onFinish
                                }) :
                                undefined
                        ], 0 /* UnknownChildren */, _$cn(`${k}-tour-step-header`)) :
                        undefined,
                    null,
                    _$ce(2, 'div', children || content, 0 /* UnknownChildren */, _$cn(`${k}-tour-step-body`)),
                    null,
                    _$ce(2, 'div', (
                        (
                            (_$blocks['footer'] = function($super) {
                                return [
                                    _$ce(2, 'div', [
                                        displayIndex,
                                        _$ct(' / '),
                                        total
                                    ], 0 /* UnknownChildren */, _$cn(`${k}-tour-step-indicator`)),
                                    _$ce(2, 'div', [
                                        (!isFirst) ?
                                            _$cc(Button, {
                                                'size': 'small',
                                                'type': 'secondary',
                                                'ev-click': onPrev,
                                                'children': prevText
                                            }) :
                                            undefined,
                                        _$cc(Button, {
                                            'size': 'small',
                                            'type': 'primary',
                                            'ev-click': isLast ? onFinish : onNext,
                                            'children': isLast ? doneText : nextText
                                        })
                                    ], 0 /* UnknownChildren */, _$cn(`${k}-tour-step-buttons`))
                                ];
                            }),
                            (__$blocks['footer'] = function($super, data) {
                                var block = $blocks['footer'];
                                var callBlock = function() {
                                    return _$blocks['footer'].call($this, $super, data);
                                };
                                return block ?
                                    block.call($this, callBlock, data) :
                                    callBlock();
                            }),
                            __$blocks['footer'](_$no)
                        )
                    ), 0 /* UnknownChildren */, _$cn(`${k}-tour-step-footer`))
                ])
            );
        }
    });
};